import { CALENDAR_EVENT_TYPES } from '@/app/(main)/calendar/consts/calendar-event-types';
import { CALENDAR_TASK_STATUS } from '@/app/(main)/calendar/consts/calendar-task-status';
import type { CalendarEvent } from '@/types/calendarTypes';

export type CalendarTaskEventColorSet = {
  backgroundColor: string;
  borderColor: string;
  textColor: string;
};

const TASK_REMINDER_COLORS = {
  backgroundColor: 'var(--color-red-300)',
  borderColor: 'transparent',
  textColor: 'var(--color-blue-300)',
} as const satisfies CalendarTaskEventColorSet;

const TASK_DEADLINE_COLORS = {
  backgroundColor: 'var(--color-grey-100)',
  borderColor: 'var(--color-neutral-400)',
  textColor: 'var(--color-blue-300)',
} as const satisfies CalendarTaskEventColorSet;

const CLOSED_TASK_COLORS = {
  backgroundColor: 'var(--color-grey-100)',
  borderColor: 'var(--color-grey-300)',
  textColor: 'var(--color-grey-500)',
} as const satisfies CalendarTaskEventColorSet;

export function calendarTaskEventColors(event: CalendarEvent): CalendarTaskEventColorSet {
  if (event.status === CALENDAR_TASK_STATUS.CLOSED) {
    return CLOSED_TASK_COLORS;
  }

  if (event.type === CALENDAR_EVENT_TYPES.TASK_REMINDER) {
    return TASK_REMINDER_COLORS;
  }

  return TASK_DEADLINE_COLORS;
}